export const Config = {
    user: {
        role: {
            customer: 'CUSTOMER',
            consultant: 'CONSULTANT',
            admin: 'ADMIN',
        }
    },
    form: {
        validation: {
            password: {
                minLength: 5
            }
        }
    },
    analytics: [{
        id: 1,
        reportKey: "high-risk-patients",
        reportName: "High Risk Patients",
        updatedDate: "Tue 07/21/2020 02:23:30 PM"
    }],
    api: {
        timer: {
            initialTime: 1800000,
            resetRequestTime: 120000,
            expiryMessage: 'Your session is about to expire. Please click reset to continue the session for 20 more minutes'
        }
    },
    looker: {
        sampleGraph: 'https://rcg1-looker.therigy.com/embed/public/hx36MWjxMJ6VFyrhXvqKSySmKgySntPK',
        sampleTable: 'https://rcg1-looker.therigy.com/embed/public/looks/hx36MWjxMJ6VFyrhXvqKSySmKgySntPK?type=table'
    },
    // cached in home page rendering
    variableGroups: null,
    API_TIMESTAMP_FORMAT: 'YYYY-MM-DD HH:mm:ss',
    UI_TIMESTAMP_FORMAT: 'M/DD/YYYY hh:mm A'
}